import doc                           from '@widesk-core/decorators/doc';
import AbstractContentToPublishModel from './AbstractContentToPublishModel';

@doc.urnResource('content_to_publish')
export default class ContentToPublishModel extends AbstractContentToPublishModel {
	declare object: unknown;

	get objectUrn(): Urn {
		return this.get('objectUrn');
	}
}
